export default {
  meta: {
    title: '搜索任务',
  },
};
